var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[(_vm.play === false)?_c('i',{staticClass:"fas fa-play-circle",on:{"click":function($event){return _vm.playMusic(true)}}}):(_vm.play === true)?_c('i',{staticClass:"fas fa-pause-circle",on:{"click":function($event){return _vm.playMusic(false)}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }